module.exports = __webpack_public_path__ + "static/media/Proced-Operac.c0a39d75.jpg";